<div class="form-group align-center" style="gap: 0; flex-flow: column;" (click)="toggleDropdown($event)">
  <div class="custom-input-placeholder custom-dropdown" style="gap: 0; flex-flow: column;">
    <!-- Input for displaying selected value or search/filter -->
    <div class="row nowrap align-center w-100" style="gap: 0;">
      <input type="text"
             class="input-control"
             placeholder="{{placeholder}}"
             [value]="getSelectedLabel()"
             (input)="filterOptions()"
             [(ngModel)]="searchText"
             style="border-right: none; text-transform: none;" />
      <svg class="select-icon" [ngClass]="{ 'select-focus-icon': dropdownOpen }" width="35" height="34" viewBox="0 0 32 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="35" height="35" stroke="transparent" stroke-opacity="0.2" />
        <path d="M10 14L16 20L22 14" stroke="#5F6366" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <!--Dropdown toggle icon-->
  </div>
  <div class="custom-input-placeholder custom-dropdown">
    <!-- Filtered options list -->
    <ul class="options-list" [class.open]="dropdownOpen" style=" top: 0;">
      <li *ngIf="filteredOptions.length > 0" class="no-options" (click)="selectOption(0, $event)">
        Select an option
      </li>
      <li *ngFor="let option of filteredOptions"
          (click)="selectOption(option, $event)">
        {{ getOptionText(option) }}
      </li>
      <li *ngIf="filteredOptions.length === 0" class="no-options" (click)="selectOption(0, $event)">
        No matching options
      </li>
    </ul>
  </div>
</div>
